import { render, staticRenderFns } from "./2_PerfilEstudiante.vue?vue&type=template&id=6825b9b8&scoped=true"
import script from "./2_PerfilEstudiante.vue?vue&type=script&lang=ts"
export * from "./2_PerfilEstudiante.vue?vue&type=script&lang=ts"
import style0 from "./2_PerfilEstudiante.vue?vue&type=style&index=0&id=6825b9b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6825b9b8",
  null
  
)

export default component.exports